import { createContext, useContext, type ReactNode } from "react"

const TransportWorkspaceScopeContext = createContext<string | null>(null)

export function TransportWorkspaceScopeProvider({
  children,
  workspaceId,
}: {
  children: ReactNode
  workspaceId: string | null
}) {
  return (
    <TransportWorkspaceScopeContext.Provider value={workspaceId}>
      {children}
    </TransportWorkspaceScopeContext.Provider>
  )
}

export function useTransportWorkspaceScope() {
  return useContext(TransportWorkspaceScopeContext)
}
